import {Vector4} from 'three'
export default [
  new Vector4(0.15, 0.39, 0.7371, 0.7597),
  new Vector4(0.15, 0.39, 0.5295, 0.6174),
  new Vector4(0.0, 0.1, 0.4955, 0.5771),
  new Vector4(0.0, 0.1, 0.4955, 0.5771),
  new Vector4(0.0, 0.1, 0.4955, 0.5771),

  new Vector4(0.0, 0.1, 0.4955, 0.5771),
  new Vector4(0.0, 0.1, 0.4955, 0.5771),
  new Vector4(0.0, 0.1, 0.4955, 0.5771),
  new Vector4(0, 0.1025, 0.388, 0.6788),
  new Vector4(0, 0.1025, 0.7144, 0.9784),

  new Vector4(0, 0.1025, 0.7144, 0.9784),
  new Vector4(0, 0.1025, 0.7144, 0.9784),
  new Vector4(0, 0.1025, 0.7144, 0.9784),
  new Vector4(0.15, 0.39, 0.7371, 0.7597),
  new Vector4(0.15, 0.39, 0.5295, 0.8),

  new Vector4(0.1, 0.2, 0.3, 0.4),
  new Vector4(0.1, 0.2, 0.4, 0.5),
  new Vector4(0.0, 0.1, 0.4955, 0.5771),
  new Vector4(0.1, 0.2, 0.4955, 0.5771),
  new Vector4(0.0, 0.1, 0.4955, 0.5771),

  new Vector4(0.0, 0.1, 0.4, 0.5),
  new Vector4(0.1, 0.2, 0.9563, 0.9921),
  new Vector4(0, 0.1025, 0.7144, 0.9784),
  new Vector4(0.1, 0.2, 0.7144, 0.9784),
  new Vector4(0.2, 0.3, 0.7144, 0.9784),
]
